import AjaxInvitationService from './ajax-invitation-service'

class VehicleService extends AjaxInvitationService {
  create ( data ) {
    let headers = this.getInvitationHeader(data.code)
    return this.makePostRequest('/by-invitation/vehicles', data, headers)
  }

  update (id, data) {
    let headers = this.getInvitationHeader(data.code)
    return this.makePutRequest(`/by-invitation/vehicles/${id}`, data, headers)
  }

  getVehicleFilesUrl () {
    return '/by-invitation/vehicle-files/'
  }

  getFileUploadUrl () {
    return this.getVehicleFilesUrl() + 'upload'
  }

  getFileDeleteUrl () {
    return this.getVehicleFilesUrl() + 'delete'
  }

  uploadFile (url, file, code) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('code', code);
    
    let headers = {
      'Content-Type': 'multipart/form-data',
      'X-INVITATION-CODE': code
    }

    return this.makeUploadRequest(url, formData, headers)
  }

  deleteFileByUrl (url, code) {
    let headers = this.getInvitationHeader(code);

    return this.makePostRequest(url, {code:code}, headers);
  }
}

const _instance = new VehicleService()
export default _instance